export default {
  en: {
    title: 'For partners',
    headline: 'Invite friends and get payouts in VND',
    share: 'Share link',
    copy: 'Copy',
    copied: 'Link copied',
    copyFailed: 'Could not copy the link',
    unavailable: 'The invite link is not ready yet',
    myBalance: 'My balance',
    howItWorks: 'How it works',
    howToEarn: 'How to earn?',
    howToWithdraw: 'How to withdraw points?',
    howMuch: 'How much do I get?',
    howMuchAnswer:
      'You earn 3% from each order of a user you referred, from the 1st to the 5th order.',
  },
  ru: {
    title: 'Партнерам',
    headline: 'Приглашайте друзей и получайте выплаты в VND',
    share: 'Поделиться ссылкой',
    copy: 'Копировать',
    copied: 'Ссылка скопирована',
    copyFailed: 'Не удалось скопировать ссылку',
    unavailable: 'Ссылка для приглашения пока недоступна',
    myBalance: 'Мой баланс',
    howItWorks: 'Как это работает',
    howToEarn: 'Как заработать?',
    howToEarnAnswer: 'Вы зарабатываете 3% с каждого заказа приведенного вами пользователя.',
    howToWithdraw: 'Как вывести баллы?',
    howToWithdrawAnswer: 'В скором времени мы подключим вывод баллов прямо на карту.',
    howMuch: 'Как еще использовать баллы?',
    howMuchAnswer: 'В ближайшее время мы подключим возможность использовать баллы для заказа.',
  },
}
